import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pane, PaneContainer, PaneTitle } from "./Panes.style";
import { setCauseAreaSelection, setOperationsPercentageByCauseArea, setOrgAmount, setGlobalOperationsEnabled } from "../../store/donation/actions";
import { nextPane } from "../../store/layout/actions";
import { State } from "../../store/state";
import { ButtonsWrapper, CauseAreaButton, CauseAreaButtonsDividerLine, getCauseAreaIconById, MultipleCauseAreaIcon } from "./SelectionPane.style";
import { Spinner } from "../../../Spinner/Spinner";
import { CauseAreaDisplayConfig } from "../../types/WidgetProps";
import { usePrefilledCauseAreaIds } from "../hooks";

/**
 * First pane: select one-time vs monthly, then choose a cause area or multiple.
 */
interface SelectionPaneProps {
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  accentColor?: string;
}
const DEFAULT_ACCENT_COLOR = "var(--primary)";
export const SelectionPane: React.FC<SelectionPaneProps> = t0 => {
  const $ = _c(58);
  const {
    causeAreaDisplayConfig,
    accentColor
  } = t0;
  const dispatch = useDispatch();
  const causeAreas = useSelector(_temp);
  const prefilledCauseAreaIds = usePrefilledCauseAreaIds();
  const {
    operationsPercentageModeByCauseArea: t1,
    causeAreaAmounts: t2
  } = useSelector(_temp2);
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const operationsPercentageModeByCauseArea = t3;
  t2 === undefined ? {} : t2;
  let t4;
  if ($[2] !== dispatch || $[3] !== operationsPercentageModeByCauseArea) {
    t4 = id => {
      const selectionType = id && id != -1 ? "single" : "multiple";
      if (selectionType === "multiple") {
        const hasAnyOperationsEnabled = Object.values(operationsPercentageModeByCauseArea).some(_temp3);
        dispatch(setGlobalOperationsEnabled(hasAnyOperationsEnabled));
      }
      dispatch(setCauseAreaSelection(selectionType, id));
      dispatch(nextPane());
    };
    $[2] = dispatch;
    $[3] = operationsPercentageModeByCauseArea;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onSelectArea = t4;
  if (!causeAreas) {
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Pane><PaneContainer><div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}><Spinner /></div></PaneContainer></Pane>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  const t5 = causeAreaDisplayConfig?.cause_area_selection_title;
  let t6;
  if ($[6] !== t5) {
    t6 = <PaneTitle>{t5}</PaneTitle>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onSelectArea) {
    t7 = () => onSelectArea(-1);
    $[8] = onSelectArea;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = accentColor || DEFAULT_ACCENT_COLOR;
  const t9 = accentColor ? "white" : "var(--secondary)";
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = {
      background: t8,
      color: t9,
      border: "1px solid var(--primary)"
    };
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = causeAreaDisplayConfig?.recommendation_button_text;
  let t12;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t7) {
    t12 = <ButtonsWrapper><CauseAreaButton key="default" onClick={t7} style={t10} data-cy="cause-area-recommendation">{t11}</CauseAreaButton></ButtonsWrapper>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CauseAreaButtonsDividerLine />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== causeAreaDisplayConfig?.below_line_cause_area_ids || $[19] !== causeAreas || $[20] !== onSelectArea || $[21] !== prefilledCauseAreaIds) {
    let t15;
    if ($[23] !== prefilledCauseAreaIds) {
      t15 = ca => ca.isActive || prefilledCauseAreaIds.has(ca.id);
      $[23] = prefilledCauseAreaIds;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    let t16;
    if ($[25] !== causeAreaDisplayConfig?.below_line_cause_area_ids) {
      t16 = ca_0 => {
        const belowLineIds = causeAreaDisplayConfig?.below_line_cause_area_ids || [4, 5];
        return !belowLineIds.includes(ca_0.id);
      };
      $[25] = causeAreaDisplayConfig?.below_line_cause_area_ids;
      $[26] = t16;
    } else {
      t16 = $[26];
    }
    let t17;
    if ($[27] !== onSelectArea) {
      t17 = ca_1 => <CauseAreaButton key={ca_1.id} onClick={() => onSelectArea(ca_1.id)} data-cy={`cause-area-${ca_1.id}`}>{getCauseAreaIconById(ca_1.id)}{ca_1.widgetDisplayName || ca_1.name}</CauseAreaButton>;
      $[27] = onSelectArea;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    t14 = causeAreas.filter(t15).filter(t16).map(t17);
    $[18] = causeAreaDisplayConfig?.below_line_cause_area_ids;
    $[19] = causeAreas;
    $[20] = onSelectArea;
    $[21] = prefilledCauseAreaIds;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[29] !== onSelectArea) {
    t15 = () => onSelectArea(undefined);
    $[29] = onSelectArea;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      marginTop: "20px"
    };
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <MultipleCauseAreaIcon />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = causeAreaDisplayConfig?.multiple_cause_areas_button_text;
  let t19;
  if ($[33] !== t15 || $[34] !== t18) {
    t19 = <CauseAreaButton onClick={t15} style={t16} data-cy="cause-area-multiple">{t17}{t18}</CauseAreaButton>;
    $[33] = t15;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t14 || $[37] !== t19) {
    t20 = <ButtonsWrapper>{t14}{t19}</ButtonsWrapper>;
    $[36] = t14;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <CauseAreaButtonsDividerLine />;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== causeAreaDisplayConfig?.below_line_cause_area_ids || $[41] !== causeAreas || $[42] !== onSelectArea || $[43] !== prefilledCauseAreaIds) {
    let t23;
    if ($[45] !== prefilledCauseAreaIds) {
      t23 = ca_2 => ca_2.isActive || prefilledCauseAreaIds.has(ca_2.id);
      $[45] = prefilledCauseAreaIds;
      $[46] = t23;
    } else {
      t23 = $[46];
    }
    let t24;
    if ($[47] !== causeAreaDisplayConfig?.below_line_cause_area_ids) {
      t24 = ca_3 => {
        const belowLineIds_0 = causeAreaDisplayConfig?.below_line_cause_area_ids || [4, 5];
        return belowLineIds_0.includes(ca_3.id);
      };
      $[47] = causeAreaDisplayConfig?.below_line_cause_area_ids;
      $[48] = t24;
    } else {
      t24 = $[48];
    }
    let t25;
    if ($[49] !== onSelectArea) {
      t25 = ca_4 => <CauseAreaButton key={ca_4.id} onClick={() => onSelectArea(ca_4.id)} data-cy={`cause-area-${ca_4.id}`}>{getCauseAreaIconById(ca_4.id)}{ca_4.widgetDisplayName || ca_4.name}</CauseAreaButton>;
      $[49] = onSelectArea;
      $[50] = t25;
    } else {
      t25 = $[50];
    }
    t22 = causeAreas.filter(t23).filter(t24).map(t25);
    $[40] = causeAreaDisplayConfig?.below_line_cause_area_ids;
    $[41] = causeAreas;
    $[42] = onSelectArea;
    $[43] = prefilledCauseAreaIds;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[51] !== t22) {
    t23 = <ButtonsWrapper>{t22}</ButtonsWrapper>;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t12 || $[54] !== t20 || $[55] !== t23 || $[56] !== t6) {
    t24 = <Pane><PaneContainer><div>{t6}{t12}{t13}{t20}{t21}{t23}</div></PaneContainer></Pane>;
    $[53] = t12;
    $[54] = t20;
    $[55] = t23;
    $[56] = t6;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
};
function _temp(state) {
  return state.layout.causeAreas;
}
function _temp2(state_0) {
  return state_0.donation;
}
function _temp3(enabled) {
  return enabled;
}